<template>
  <UiModal
    :show="showHistory"
    title="兑换记录"
    iconType="store_1"
    :empty="!historyList || historyList.length === 0"
    @close="close"
  >
    <div class="history-box">
      <div class="inner" v-if="historyList && historyList.length !== 0">
        <p v-for="(item, key) in historyList" :key="key">
          {{
            `${formatDay(item?.createAt)}, 消耗 ${
              item?.cost * item?.num
            }竞猜币, 兑换商品【${item?.desc}】* ${item?.num}`
          }}
        </p>
      </div>
      <UiEmpty v-else tip="暂无兑换记录" hook="px" />
    </div>
  </UiModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import * as api from "@/service/index";
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import UiModal from "@/components/ui-modal.vue";
import UiEmpty from '@/components/ui-empty';

const appStore = useAppStore()

const showHistory = ref(false)
const historyList = ref([])

const token = computed(() => appStore.token)

const { close } = useModal('store-history', showHistory, {
  async onOpen() {
    if (!token.value) return
    const response = await api.reqStoreHistory({ token: token.value })
    if (response.status === 200) {
      historyList.value = Array.isArray(response.data) ? response.data : response.data.data
    }
  }
})

function formatDay(time) {
  const isoDateString = time.replace(" ", "T");
  let dateObj = new Date(isoDateString);
  let month = dateObj.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = dateObj.getDate();
  day = day < 10 ? "0" + day : day;

  return `${month}月${day}日`;
}
</script>

<style lang="scss" scoped>
.history-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 32px 34px 54px;
	font-size: 20px;
	color: #666;

	.inner {
    height: 100%;
    overflow-y: scroll;
    padding-inline: 40px;
    color: #666;

		p {
			position: relative;
			margin: 8px 0;
      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: -40px;
        width: 27px;
        height: 27px;
        @include icon_status('rule_bullet');
      }
		}
	}

	::-webkit-scrollbar {
		display: block !important;
	}
}
</style>
